import React, { Component } from 'react'
import Grid from '../grid'

class Actions extends Component {
  render () {
    const children = React.Children.toArray(this.props.children)

    if (children.length === 0) {
      return null
    }

    return (
      <Grid align='center'>
        {this.props.children}
      </Grid>
    )
  }
}

Actions.displayName = 'Actions'

export default Actions



// WEBPACK FOOTER //
// ./src/app/shared/elements/actions/index.js